import React, { useContext } from "react";
import { Card, Icon, Label, Image, Button } from "semantic-ui-react";
import moment from "moment";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/auth";
import LikeButton from "./LikeButton";
import DeleteButton from "./DeleteButton";
import MyPopup from "../util/MyPopup";




function PostCard({ post: { id, body, createdAt, username, likes, likeCount, commentCount } }) {
  const { user } = useContext(AuthContext);



  return (
    <Card fluid>
      <Card.Content>
        <Image floated='right' size='mini' src="https://www.freeiconspng.com/uploads/person-icon-blue-18.png" />
        <Card.Header as={Link} to={`/posts/${id}`}>{username}</Card.Header>
        <Card.Meta as={Link} to={`/posts/${id}`}>{moment(createdAt).fromNow(true)}</Card.Meta>
        <Card.Description>{body}</Card.Description>
      </Card.Content>
      <Card.Content extra>
        <LikeButton user={user} post={{ id, likes, likeCount }} />

        <MyPopup content="Comment on post">
          <Button labelPosition='right' as={Link} to={`/posts/${id}`}>
              <Button color='blue' basic><Icon name='comments' /></Button>
              <Label basic color='blue' pointing='left'>{commentCount}</Label>
          </Button>
        </MyPopup>  
        {user && user.username === username && <DeleteButton postID={id} />}
      </Card.Content>
    </Card>
  )
}

export default PostCard;